<template>
  <form class="ovg-form" @submit.prevent="onSubmit">
    <div class="ovg-row">
      <div class="ovg-field ovg-field--320">
        <label class="ovg-label" for="input-modelos">Modelo*</label>
        <vue-typeahead-bootstrap
          id="input-modelos"
          v-model="modelQuery"
          class="ovg-typeahead"
          :class="{ 'ovg-typeahead--error': modeloError }"
          input-class="ovg-input"
          :data="modelsOptions"
          :serializer="(s) => s.text"
          :minMatchingChars="0"
          placeholder="Escribe el nombre del modelo"
          @hit="onModelHit"
          @input="onModelSearch"
        />
        <p v-if="modeloError" class="ovg-error">Campo requerido</p>
      </div>
    </div>

    <div class="ovg-row">
      <div class="ovg-field ovg-field--320">
        <label class="ovg-label" for="input-serial">Número de Serie S/N*</label>
        <input
          id="input-serial"
          v-model.trim="formEquipment.serial_number"
          type="text"
          class="ovg-input"
          :class="{
            'ovg-input--error':
              $v.formEquipment.serial_number.$dirty &&
              $v.formEquipment.serial_number.$invalid,
          }"
          :maxlength="LARGO_SERIE"
          placeholder="Está en la etiqueta inferior de tu equipo"
          @blur="$v.formEquipment.serial_number.$touch()"
        />
        <p
          v-if="
            $v.formEquipment.serial_number.$dirty &&
            !$v.formEquipment.serial_number.required
          "
          class="ovg-error"
        >
          Campo requerido
        </p>
        <p
          v-else-if="
            $v.formEquipment.serial_number.$dirty &&
            !$v.formEquipment.serial_number.minLength
          "
          class="ovg-error"
        >
          El N° de serie debe tener exactamente {{ LARGO_SERIE }} caracteres
          (actual: {{ formEquipment.serial_number.length }}).
        </p>
      </div>
      <div class="ovg-field ovg-field--320">
        <label class="ovg-label" for="input-password">Password</label>
        <input
          id="input-password"
          v-model="formEquipment.password"
          type="text"
          class="ovg-input"
          placeholder="Opcional"
        />
      </div>
    </div>

    <div class="ovg-row">
      <div class="ovg-field">
        <label class="ovg-label" for="input-power">Incluye Cargador</label>
        <select
          id="input-power"
          v-model="formEquipment.power_source"
          class="ovg-select"
        >
          <option value="" disabled hidden>Selecciona</option>
          <option
            v-for="opt in chargerOptions"
            :key="String(opt.value)"
            :value="opt.value"
          >
            {{ opt.text }}
          </option>
        </select>
      </div>
      <div class="ovg-field">
        <label class="ovg-label" for="input-hardDriveSize">Disco Duro</label>
        <select
          id="input-hardDriveSize"
          v-model="formEquipment.size_hard_drive"
          class="ovg-select"
        >
          <option value="" disabled hidden>Selecciona Capacidad</option>
          <option
            v-for="opt in hardDriveOptions"
            :key="String(opt.value)"
            :value="opt.value"
          >
            {{ opt.text }}
          </option>
        </select>
      </div>
      <div class="ovg-field">
        <label class="ovg-label" for="input-ram">Memoria RAM</label>
        <select
          id="input-ram"
          v-model="formEquipment.total_ram_memorie"
          class="ovg-select"
        >
          <option value="" disabled hidden>Selecciona</option>
          <option
            v-for="opt in ramOptions"
            :key="String(opt.value)"
            :value="opt.value"
          >
            {{ opt.text }}
          </option>
        </select>
      </div>
    </div>

    <div class="ovg-card__footer ovg-card__footer--between">
      <button type="button" class="ovg-btn ovg-btn--secondary" @click="goBack">
        Paso Anterior
      </button>
      <button type="submit" class="ovg-btn ovg-btn--primary">
        Siguiente Paso
      </button>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
import {
  chargerOptions,
  hardDriveOptions,
  ramOptions,
} from '../../NewOT/options'

// Equipo.serial_number en el back es varchar(15) con MinLengthValidator(15)
const LARGO_SERIE = 15

const desdeRetorno = (equipo) => ({
  serial_number: equipo.serial_number,
  password: equipo.password,
  size_hard_drive: equipo.size_hard_drive,
  power_source: equipo.power_source,
  total_ram_memorie: equipo.total_ram_memorie,
  model_name: equipo.model_name,
  modelo: equipo.modelo,
})

export default {
  name: 'DataEquipmentRegions',
  components: {
    VueTypeaheadBootstrap,
  },
  props: ['setFormEquipment', 'returnEquipment'],
  validations: {
    formEquipment: {
      modelo: { required },
      serial_number: {
        required,
        minLength: minLength(LARGO_SERIE),
        maxLength: maxLength(LARGO_SERIE),
      },
    },
  },
  data() {
    return {
      LARGO_SERIE,
      formEquipment: desdeRetorno(this.returnEquipment),
      modelQuery: this.returnEquipment.model_name || '',
      chargerOptions,
      hardDriveOptions,
      ramOptions,
    }
  },
  computed: {
    ...mapGetters('EquipmentStore', ['models']),
    modelsOptions() {
      return this.models.map((val) => {
        const tipoNombre = val.tipo_dispositivo
          ? val.tipo_dispositivo.nombre
          : '-'
        return {
          value: val.id,
          text: `${tipoNombre} - ${val.model_name} - ${val.part_number}`,
        }
      })
    },
    modeloError() {
      return (
        this.$v.formEquipment.modelo.$dirty &&
        !this.$v.formEquipment.modelo.required
      )
    },
  },
  watch: {
    returnEquipment: {
      handler() {
        this.formEquipment = desdeRetorno(this.returnEquipment)
        this.modelQuery = this.returnEquipment.model_name || ''
      },
      deep: true,
    },
  },
  created() {
    this.getModels(this.modelQuery)
  },
  methods: {
    ...mapActions('EquipmentStore', ['getModels']),
    onModelHit(opcion) {
      this.formEquipment.modelo = opcion.value
      this.formEquipment.model_name = opcion.text
      this.$v.formEquipment.modelo.$touch()
    },
    onModelSearch(query) {
      if (query !== this.formEquipment.model_name) {
        this.formEquipment.modelo = null
        this.formEquipment.model_name = null
      }
      this.getModels(query)
    },
    onSubmit() {
      if (this.$v.$invalid) {
        this.$bvToast.toast('Complete todo los campos requeridos', {
          variant: 'danger',
        })
        this.$v.$touch()
      } else {
        this.setFormEquipment({ ...this.formEquipment })
      }
    },
    goBack() {
      this.$emit('goBack')
    },
  },
}
</script>
